import { Toast } from "antd-mobile";

// 对URL参数值进行彻底解码，处理双重/多重编码的情况
// 例如: %257B -> %7B -> { (需要两次解码)
function deepDecodeURIComponent(value: string): string {
  let decoded = value;
  for (let i = 0; i < 3; i++) {
    try {
      const further = decodeURIComponent(decoded);
      if (further === decoded) break; // 已经完全解码
      decoded = further;
    } catch {
      break; // 无法继续解码，停止
    }
  }
  return decoded;
}

export function parse(url = window.location.search) {
  const obj: { [key: string]: string } = {};
  const arr = url.match(new RegExp("[?&][^?&]+=[^?&]+", "g")) || [];
  try {
    if (arr.length) {
      arr.forEach((item) => {
        const pairStr = item.substring(1);
        const equalIndex = pairStr.indexOf('=');
        const key = deepDecodeURIComponent(pairStr.substring(0, equalIndex));
        const val = deepDecodeURIComponent(
          pairStr.substring(equalIndex + 1, pairStr.length)
        );
        obj[key] = val;
      });
    }

    const hashString = window.location.hash || "";

    if (hashString && hashString.indexOf("?") >= 0) {
      const queryStringArr = hashString.substring(hashString.indexOf("?") + 1).split("&");
      queryStringArr.forEach((item) => {
        const itemArr = item.split("=");
        obj[itemArr[0]] = itemArr[1];
      });
    }
  } catch (err) {
    Toast.show("url参数错误");
  }
  return obj;
}

export const urlQuery = {
  ...parse(),
};
